import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tabs, Tab, Chip } from "@mui/material";

const ENV_ORDER = ["PRODUCTION", "STAGING", "DEVELOPMENT", "SANDBOX"];
const ENV_COLORS = {
  PRODUCTION: "error",
  STAGING: "warning",
  DEVELOPMENT: "info",
  SANDBOX: "default",
};

export default function EnvironmentSwitcher({ currentSite, siblings }) {
  const navigate = useNavigate();

  // Build ordered list: current + siblings
  const allEnvs = [
    {
      id: currentSite.id,
      environment: currentSite.environment,
      domain: currentSite.domain,
      status: currentSite.status,
    },
    ...siblings,
  ].sort(
    (a, b) =>
      ENV_ORDER.indexOf(a.environment) - ENV_ORDER.indexOf(b.environment),
  );

  const currentIndex = allEnvs.findIndex((e) => e.id === currentSite.id);

  const handleChange = (_, newValue) => {
    const target = allEnvs[newValue];
    if (target && target.id !== currentSite.id) {
      navigate(`/dashboard/sites/${target.id}`);
    }
  };

  return (
    <Box sx={{ mt: 2, borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={currentIndex}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {allEnvs.map((env) => (
          <Tab
            key={env.id}
            label={
              <Chip
                label={
                  env.environment.charAt(0) +
                  env.environment.slice(1).toLowerCase()
                }
                color={ENV_COLORS[env.environment] || "default"}
                size="small"
                variant={env.id === currentSite.id ? "filled" : "outlined"}
              />
            }
          />
        ))}
      </Tabs>
    </Box>
  );
}
